import * as ng from 'angular';
import { Dropzone } from './dropzone.directive';

export const DropzoneModule: string =
    ng.module('dropzone', [
    ])
        .directive('dropzone', Dropzone)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropzone/dropzone.module.ts